import React, { useEffect, useRef, useState } from "react";
import useTranslationHook from "../hooks/useTranslationHook";
import { useDispatch, useSelector } from "react-redux";
import { createPortal } from "react-dom";
import { useForm, useWatch } from "react-hook-form";
import { DeleteAccountSchema } from "../../utils/validations";
import { yupResolver } from "@hookform/resolvers/yup";
import {
    sendDeleteAccountOTP,
    verifyDeleteAccountOTP,
} from "../../redux/action/authAction";
import { handleAccountVerificationStatusModal, handleDeleteAccountModal } from "../../redux/slice/modalSlice";
import { ACCOUNT, accountStatus, PROFILE_IMG } from "../../utils/constants";
import { handleAccountStatus } from "../../redux/action/verificationAction";
import { Link } from "react-router-dom";

function AccoutVerifiedStatusModal() {
    const { t } = useTranslationHook();
    const show = useSelector((state) => state.modal.accountVerificationStatusModal);
    const user = useSelector((state) => state.auth.user);
    const dispatch = useDispatch();
    const handleClose = () => {
        dispatch(handleAccountVerificationStatusModal(false));
    }
    const handleClick = () => {
        handleClose()
        if (user?.is_account_verified === accountStatus.success) {
            dispatch(handleAccountStatus(accountStatus.success));
        } else if (user?.is_account_verified === accountStatus.under_review) {
            dispatch(
                loadUser({
                    site_id: user.site_id,
                })
            ).then((res) => {
                if (res?.error === 0) {
                    dispatch(handleAccountStatus(res.data.is_account_verified));
                }
            });
        } else dispatch(handleAccountStatus(""));
    };








    ;



    useEffect(() => {
        document.body.classList.toggle("modal-open", show);
        !show && reset();
        return () => {
            document.body.classList.remove("modal-open");
        };
    }, [show]);


    return createPortal(
        <div
            className={`modal fade ${show ? "show d-block" : ""} purchase-modal`}
            tabIndex="-1"
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5
                            className="modal-title d-flex align-items-center"
                            style={{ gap: "12px" }}
                        >
                            {t("Account Verification Status")}
                        </h5>

                        <button
                            type="button"
                            className="btn-close"
                            onClick={handleClose}
                            aria-label="Close"
                        />
                    </div>

                    <div className="modal-body pb-0">
                        {user?.is_account_verified &&
                            user?.is_account_verified !==
                            accountStatus.success && (
                                <div className="verified-box">
                                    <div className="alert alert-rejected">
                                        <img
                                            src="/img/info-icon-ornge.svg"
                                            alt="Info Icon"
                                        />
                                        {user.is_account_verified ===
                                            accountStatus.not_verify &&
                                            t(
                                                "Your account is not verified"
                                            )}
                                        {user.is_account_verified ===
                                            accountStatus.under_review &&
                                            t(
                                                "Your account is under review"
                                            )}
                                        {user.is_account_verified ===
                                            accountStatus.unsuccess &&
                                            t(
                                                "We couldn’t verify your account. Please try again."
                                            )}
                                    </div>
                                    <Link
                                        to="/verify"
                                        className="verify-btn btn btn-primary"
                                        onClick={handleClick}
                                    >
                                        {user.is_account_verified ===
                                            accountStatus.not_verify
                                            ? t("Verify Now")
                                            : user.is_account_verified ===
                                                accountStatus.under_review
                                                ? t("View Current Status")
                                                : t("Retry Verification")}
                                    </Link>
                                </div>
                            )}
                    </div>
                </div>
            </div>
        </div>,
        document.getElementById("root")
    );
}

export default AccoutVerifiedStatusModal
    ;
